import { render } from "./NotFoundView.vue?vue&type=template&id=6f30becc"
const script = {}

import exportComponent from "/home/runner/work/guild-vue/guild-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__